import React from "react";
import styled from "styled-components";
import Image from "gatsby-image";
import Breakpoints from "../components/styles/Breakpoints";
import { HeroHeader, Header4 } from "../components/typography";
import { Colors } from "../components/styles/Colors";
import { PrimaryButton } from "../components/Button";
import { Link } from "gatsby";
import richText from "../utils/richText";

const Wrapper = styled.div`
  position: relative;

  .gatsby-image-wrapper {
    min-height: 350px;
  }
`;

const Content = styled.div`
  position: relative;
  width: 100%;
  height: auto;
  top: 0px;
  left: 0px;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-direction: column;
  background-color: ${Colors.deepHunter};
  padding: 30px;

  @media ${Breakpoints.desktop} {
    position: absolute;
    background-color: transparent;
    width: 50%;
    height: 100%;
    padding: 0 0 0 10%;
  }

  .text {
      max-width: 450px;
      display: flex;
      flex-direction: column;
      align-items: flex-start;

      @media ${Breakpoints.desktop} {
        max-width: 450px;
      }
  }

  .footer {
      position: absolute;
      bottom: 50px;
      color: white;
      display: none;

      @media ${Breakpoints.desktop} {
        max-width: 450px;
        display: block;
      }
  }

  ${HeroHeader} {
    color: ${Colors.white};
    margin-bottom: 20px;

    @media ${Breakpoints.desktop} {
      margin-bottom: 40px;
    }
  }

  ${Header4} {
    color: ${Colors.white};
    margin-bottom: 20px;

    @media ${Breakpoints.desktop} {
      margin-bottom: 40px;
    }
  }

  ${PrimaryButton} {
    width: 100%;
    background-color: transparent;
    border: 1px solid white;
    transition: background-color .3s, color .3s;
    color: ${Colors.white};

    @media ${Breakpoints.desktop} {
      width: auto;
    }

    &:hover {
        background-color: ${Colors.white};
        color: ${Colors.hunter};
    }
  }
`

export default function BGImageHeroLeft({ image, title, subtitle, footer }) {
  return (
    <Wrapper>
      <Image fluid={image} />
      <Content>
        <div className="text">
            <HeroHeader>{title}</HeroHeader>
            <Header4>{subtitle}</Header4>
            <PrimaryButton as={Link} to="/products/the-complete-routine">
                Create a subscription
            </PrimaryButton>
        </div>

        <div className="footer">
            {richText(footer)}
        </div>
      </Content>
    </Wrapper>
  );
}
